export default __webpack_public_path__ + "static/media/report.cf303aa9.svg";